import { Box, Container, Typography, Link, BoxProps } from '@mui/material';
import { ReactNode } from 'react';

export interface FooterProps extends BoxProps {
  copyright?: string;
  links?: Array<{ label: string; href: string }>;
  children?: ReactNode;
}

export const Footer = ({
  copyright,
  links,
  children,
  sx,
  ...props
}: FooterProps) => {
  const currentYear = new Date().getFullYear();
  const copyrightText = copyright || `© ${currentYear} All rights reserved`;

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        ...sx,
      }}
      {...props}
    >
      <Container maxWidth="lg">
        {children || (
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Typography variant="body2" color="text.secondary">
              {copyrightText}
            </Typography>
            {links && (
              <Box sx={{ display: 'flex', gap: 2 }}>
                {links.map((link, index) => (
                  <Link
                    key={index}
                    href={link.href}
                    color="inherit"
                    underline="hover"
                  >
                    {link.label}
                  </Link>
                ))}
              </Box>
            )}
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default Footer;
